module.exports = __webpack_public_path__ + "static/media/sort-alpha-down-alt.9825d491.svg";